import React from 'react';
import { withTranslation } from 'react-i18next';
class AddCatgeory extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            id: this.props.property.id != undefined && this.props.property.id.length ? this.props.property.id : '',
            name: this.props.property.name != undefined && this.props.property.name.length ? this.props.property.name: '',
            description: this.props.property.description != undefined && this.props.property.description.length ? this.props.property.description : '',
            error:false,
        }
        this.onChangeAttr = this.onChangeAttr.bind(this);
        this.saveValues = this.saveValues.bind(this);
    }

    onChangeAttr(e,attr){
        let error = this.state.error;
        if(attr == 'name'){
            error = false;
        }

        this.setState({
            [attr]:e.target.value,
            error:error
        });
    }

    saveValues(){
        let error = this.state.error;
        let name = this.state.name;
        if(!error && name){
            if(typeof this.props.property.callBack === 'function'){
                this.props.property.callBack(this.state);
            }
        }else{
            this.setState({
                error:true,
            })
        }
    }

    render(){
        let id = this.state.id;
        let name = this.state.name;
        let description = this.state.description;
        let popupTitle = this.props.property.title;
        const { t } = this.props
        return (
            <div>
               <div className="AddWsCustmPopWrap">
                    <div className="AddWsCustmHead ">
                        <div className="popupWrap">
                            <div className="headLable">{popupTitle}</div>
                            <div className="headClose" onClick ={this.props.property.cancel}> <img className="closeX" src={wbConfig.baseUrl + "/images/ai-v1-assets/x.png"}/></div>
                        </div>
                    </div>

                    <div className="AddWsCustmBoay ">   
                        <div className="popupWrap">
                            <div className="col">
                                <div className="lable">{t('Category Name')}</div>
                                <input  className="input categoryId"  type="hidden"  name="categoryId"  value={id} onChange={(e) => this.onChangeAttr(e,'id')}/>
                                <div className="content">
                                    <input  className="input categoryName"  type="text"  name="categoryName"  value={name} onChange={(e) => this.onChangeAttr(e,'name')}/>
                                {
                                    this.state.error &&
                                    <lable className="errorText">{t('Please enter field name')}</lable>
                                }
                                </div>
                                
                            </div>
                            <div className="col descrp">
                                <div className="lable">{t('Description')}</div>
                                <div className="content">
                                    <textarea  name='description' className="input cateDescription" placeholder={t("Optional")} rows="6" onChange={(e) => this.onChangeAttr(e,'description')} value={description} />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="AddWsCustmBtn ">
                        <div className="btnSave" onClick={(e) => this.saveValues()}>Save</div>
                    </div>
               </div>
            </div>
        );
    }

}
AddCatgeory.defaultProps = {
    id: "",
    name: "",
    description: "",
};

export default  withTranslation()(AddCatgeory);